export enum SINK_OPTIONS {
  BROWSE_SINKS = 'BROWSE_SINKS',
  SUPPLY_SINKS = 'SUPPLY_SINKS',
  NO_SINKS = 'NO_SINKS',
}
